export default __webpack_public_path__ + "static/media/wTop_2_c3.adacbb19.jpeg";